// @ts-nocheck
import React, { useState } from 'react';

import * as styles from './styles';
import { Button, Typography } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';

import { Location } from '@cobliteam/common-types';

import { DescriptionTitle, HintPopup, Popper } from '@cobliteam/base-components';

import Icon from '@cobliteam/ui/icons';

interface CameraIdentifierProps {
  hasCta?: boolean;
  className?: string;
  customTooltipLabel?: string;
}

export const CameraIdentifier: React.FC<CameraIdentifierProps> = React.memo(({ hasCta = false, className, customTooltipLabel }) => {
  const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLElement) | null>(null);
  const [isCtaOpen, setIsCtaOpen] = useState(false);
  const tooltipLabel = customTooltipLabel || 'Veículo equipado com Cobli Cam';

  const handleCtaOpen = (event: React.MouseEvent<HTMLElement>) => {
    const { currentTarget } = event;

    setAnchorEl(currentTarget);
    setIsCtaOpen(true);
  };

  const handleCtaClose = () => {
    setIsCtaOpen(false);
  };

  const handleCtaClick = () => {
    window.open(Location.CAMERA_EVENTS, '_blank');
  };

  return (
    <div className={cn(className, styles.videocamIconWrapper(hasCta))} onClick={handleCtaOpen}>
      <HintPopup title={tooltipLabel} arrow placement={hasCta ? 'bottom' : 'top'}>
        <Icon name='video' />
      </HintPopup>
      {hasCta && (
        <Popper arrow handleMouseLeave={handleCtaClose} open={isCtaOpen} placement='top' anchorEl={anchorEl}>
          <DescriptionTitle>Veículo equipado com Cobli Cam</DescriptionTitle>
          <Typography variant='body' className='mt-2.5'>
            Para ver eventos capturados pela Cobli
            <br />
            Cam, acesse a aba clicando no botão
            <br />
            abaixo.
          </Typography>
          <Button variant='text' onClick={handleCtaClick}>
            Ver Cobli Cam
          </Button>
        </Popper>
      )}
    </div>
  );
});

export default CameraIdentifier;
